import React from "react";
import { connect } from "react-redux";
import {SUPERADMIN, ADMIN, PRODUCTOR, RRPP, DEFAULT, REDIMIDOR} from "../config/RolesConstants"
import {EVENTS_ROUTE, USERS_ROUTE, LOGIN_ROUTE} from "../config/RoutesConstants"
import { withRouter } from "react-router-dom";
import { 
  Container, 
  IconButton,
  Icon,
  Button,
  Box, 
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  DialogTitle,
  Paper,
  Typography, 
  Fab,
  Toolbar,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableFooter,
  TablePagination,
  Tooltip,
  Input,
} from "@material-ui/core"
import { withTheme } from "@material-ui/core/styles"
class Home extends React.PureComponent{

  render(){
    const {login, theme} = this.props
    let roles = this.props.profile&&this.props.profile.proRoles
    console.log("ROLES HOME", roles)
    if(login){
      if(roles){
        if(roles.some((r)=>{return r.id==SUPERADMIN||r.id==PRODUCTOR||r.id==REDIMIDOR})){
          this.props.history.replace(EVENTS_ROUTE)
        }else{
          
          if(roles.some((r)=>{console.log("HOME", r, r.id, ADMIN); return r.id==ADMIN})){
            this.props.history.replace(USERS_ROUTE)
          } 
        }
      }
    }else{
      this.props.history.replace(LOGIN_ROUTE)
    }
    return (
      <Box style={theme.mainContainer}>
            <Typography>Home</Typography>
      </Box>
    )
  }
}

function mapStateToProps(store) {
  return {
    login: store.auth.login,
    profile: store.auth.profile,
  };
}

export default  withRouter(
                  withTheme(
                    connect(
                      mapStateToProps
                    )(Home)
                  )
                )


// WEBPACK FOOTER //
// ./src/screens/Home.js